import { collectionPath } from './shopCategories'
import { SITE_LINKS } from './siteLinks'
import { servicePath } from './servicePages'

/**
 * Everything Fabritech sells or does, as shown on the home page (category strip, "All Categories"
 * menu, mobile menu). Every entry links to a page (`to`): a shop category or a service page.
 */
export const HOME_OFFERINGS = [
  {
    id: 'starlink',
    name: 'Fiber & Starlink Internet',
    icon: 'fa-wifi',
    image: '/assets/img/slider/net.jpeg',
    to: collectionPath('starlink'),
  },
  {
    id: 'cctv',
    name: 'CCTV & Surveillance',
    icon: 'fa-video',
    image: '/assets/img/shop/categories/cctv-cameras.png',
    to: collectionPath('digital-security'),
  },
  {
    id: 'access-control',
    name: 'Access Control & Alarms',
    icon: 'fa-fingerprint',
    image: '/assets/img/service/security-cards/smart-lock-web.jpg',
    to: SITE_LINKS.serviceSecurity,
  },
  {
    id: 'networking',
    name: 'Networking & IT',
    icon: 'fa-network-wired',
    image: '/assets/img/service/network-cards/rj45.jpg',
    to: SITE_LINKS.serviceNetwork,
  },
  {
    id: 'power',
    name: 'Power Backup & UPS',
    icon: 'fa-plug-circle-bolt',
    image: '/assets/img/shop/categories/power-accessories.png',
    to: collectionPath('power-backup'),
  },
  {
    id: 'software',
    name: 'Software Development',
    icon: 'fa-code',
    image: '/assets/img/home/service-software.jpg',
    to: servicePath('software-solutions'),
  },
  {
    id: 'paytv',
    name: 'Canal+ & DStv',
    icon: 'fa-tv',
    image: '/assets/img/home/service-canal-dstv.jpg',
    to: servicePath('canal-dstv'),
  },
  {
    id: 'training',
    name: 'Training Center',
    icon: 'fa-graduation-cap',
    image: '/assets/img/home/service-training.jpg',
    to: servicePath('training-center'),
  },
  {
    id: 'shop',
    name: 'All Products',
    icon: 'fa-store',
    image: '/assets/img/product/shop.jpeg',
    to: SITE_LINKS.shop,
  },
]

const byId = Object.fromEntries(HOME_OFFERINGS.map((item) => [item.id, item]))

/** Main nav links on the home header. `shopCategory` adds a dropdown of that shop category's subcategories. */
export const HOME_NAV = [
  { ...byId.starlink, name: 'Internet', shopCategory: 'starlink' },
  { ...byId.cctv, shopCategory: 'digital-security' },
  { ...byId['access-control'], name: 'Access Control' },
  byId.networking,
  { ...byId.power, name: 'Power & Backup', shopCategory: 'power-backup' },
  { ...byId.software, name: 'Software' },
  byId.training,
]
